<template>
    <span v-click-outside="hide" class="combo">
      <div v-if="company !== 'bw'">
        <span class="status" :style="line.status ? 'background:' + (line.status.color || 'black') : ''" @click="showStatus=(!showStatus && canEdit)"/>
        <span id="status-box" v-if="showStatus">
            <span v-for="(st, index) in status" :key="index">
                <span class="status combo-opt" :style="{background: st.color}" :title="$t(st.description)" @click="setStatus(st)"/>
            </span>
        </span>
      </div>
      <div v-else>
        <span class="reason" @click="showStatus=(!showStatus && canEdit)"> {{ $t(line.status.description) }}</span>
        <span id="status-box" v-if="showStatus">
            <span v-for="(st, index) in status" :key="index">
                <span class="combo-opt" :title="$t(st.description)" @click="setStatus(st)">{{ $t(st.description) }}</span>
            </span>
        </span>
      </div>
    </span>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'status-combo',
  components: {},
  props: {
    status: {default: () => { return [] }},
    line: {},
    type: '',
    company: ''
  },
  created () {
    this.$emit('loading')
  },
  mounted () {
    this.checkPermissions(['editStatus']).then((response) => { this.canEdit = response })
  },
  data () {
    return {
      showStatus: false,
      canEdit: false
    }
  },
  methods: {
    ...mapActions({
      checkPermissions: 'auth/checkPermissions'
    }),
    hide () {
      this.showStatus = false
    },
    setStatus (st) {
      this.$emit('statusChanged', { status: st })
      this.hide()
    }
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vNode) {
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
          console.warn(warn)
        }
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },
      unbind: function (el, binding) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
.status {
  transition: .3s;
}
.combo-opt {
  margin: .5em auto;
  text-transform: uppercase;
}
#status-box {
  transition: .3s;
  position: absolute;
  top: 3em;
  left: 0;
  background: white;
  // width: 100%;
  border: 1px solid #E1E1E1;
  box-sizing: border-box;
  z-index: 999;
  padding: .3em;
}
</style>



// WEBPACK FOOTER //
// src/components/StatusCombo.vue